module.exports = __webpack_public_path__ + "assets_app/img/key-4.934b704f.svg";